import { useCallback } from 'react'
import { useArticleContext } from '../../_core'
import SocialMediaTextSettingView from './SocialMediaTextSettingView'
import { useDefaultOgText } from './useDefaultOgText'

function SocialMediaTextSetting() {
  const {
    dispatch,
    ActionType,
    articleState: { ogTitle, ogDescription },
  } = useArticleContext()

  const { defaultOgTitle, defaultOgDescription } = useDefaultOgText()

  const updateOgTitleChange = useCallback(
    (value: string) => {
      dispatch({ type: ActionType.UPDATE_OG_TITLE, value })
    },
    [dispatch, ActionType],
  )

  const updateOgDescriptionChange = useCallback(
    (value: string) => {
      dispatch({ type: ActionType.UPDATE_OG_DESCRIPTION, value })
    },
    [dispatch, ActionType],
  )

  return (
    <SocialMediaTextSettingView
      initialOgTitle={ogTitle}
      defaultOgTitle={defaultOgTitle}
      updateOgTitleChange={updateOgTitleChange}
      initialOgDescription={ogDescription}
      defaultOgDescription={defaultOgDescription}
      updateOgDescriptionChange={updateOgDescriptionChange}
    />
  )
}

export default SocialMediaTextSetting
